const getSubCategories = (categoryProperties) => {
  const subCategory = categoryProperties?.subCategory;
  if (!subCategory) {
    return [];
  }
  return [subCategory, ...getSubCategories(categoryProperties.categoryProperties)];
};

export default getSubCategories;
